import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Style.
 */

const StyledDiv = styled.div`
  text-align: center;
  height: 100%;

  display: flex;
`;

const StyledTitleDiv = styled.div`
  margin: auto;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
`;

export const SidePanelOfflinePlaceholder: FC = () => (
  <StyledDiv>
    <StyledTitleDiv>
      <Trans id="sidepanel-offline-state">Not available offline</Trans>
    </StyledTitleDiv>
  </StyledDiv>
);
